/*产品展示item*/
import { getCatlogsAction } from '@ivymobi/orbit-core/business/productCenter';
import { filter, isUndefined, union } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TenantContext, UserContext } from '../../orbit-context';
import { Loading } from '../../components';
import {
  Box,
  Divider,
  Grid,
  IconButton,
  Theme,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import './selectionItem.css';
import { MoreHoriz } from '@mui/icons-material';
import _ from 'lodash';
const ControlPanel = (props) => {
  const {data,setModeOptions,modeOptions} = props;
  console.log('data===',data)
  return (
    <Box style={{padding:'20px',background:'white'}}>
        <Box  style={{padding:'10px'}}>
                   <Box style={{fontSize:'17px'}}>
                    选择结果
                  </Box>
                  <Typography style={{fontSize:'12px',opacity:'0.4'}}>选型结果仅供参考</Typography>
                  <Table stickyHeader >
                      <TableHead>
                        <TableRow>
                          <TableCell style={{backgroundColor:'white'}}>名称</TableCell>
                          <TableCell style={{backgroundColor:'white'}} align="center">型号</TableCell>
                          <TableCell style={{backgroundColor:'white'}} align="right">操作</TableCell>
                        </TableRow> 
                      </TableHead>
                      <TableBody>
                        {data?.productsData?.map((row) => (
                          <TableRow key={row.name}>
                            <TableCell component="th" scope="row">
                            {_.get(row,'details.descriptionShort.zh')}
                            </TableCell>
                            
                            <TableCell align='center'> {row.featuresDic['IF000002']?.fvalue}</TableCell>
           
                            {(!modeOptions?.control || modeOptions.control.id!=row.id)&& <TableCell align="right"><Button variant='contained' 
                                style={{ background:'#ece8e8',color:'red',width:'150px'}}
                                onClick={()=>{
                                  setModeOptions({...modeOptions,control:row,controlId:row.id,controlCataId:data.id},22)
                                  // setRobotSelect(row);
                                }}
                              >
                                加入选型清单 +
                              </Button></TableCell>}
                              {(modeOptions?.control && modeOptions.control.id===row.id)&& <TableCell align="right"><Button variant='contained' 
                                style={{ background:'#ece8e8',color:'red'}}
                                onClick={()=>{
                                  setModeOptions({...modeOptions,control:null,controlId:null},23)
                                }}
                              >
                                已加入 -
                              </Button></TableCell>}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
        </Box>
    </Box>); 
};
const useStyles = makeStyles((theme: Theme) => createStyles({
 
  item:{
    background:'#fbfbfb',
    marginRight:'20px' ,
    padding:'9px',
    margin:'3px'  
  },
  selectItem:{
    background:'#fbf1f1',
    marginRight:'20px' ,
    padding:'9px',
    margin:'3px',
    border:'1px solid #f28f90!important'
  }


}));

export default ControlPanel;